<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label">Грузополучатель</div>
            <div class="dx-field-value">
                <ai-text-box-dictionary :value="data?.code" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { inject } from 'vue';
import AiTextBoxDictionary from '@/components/ai-text-box-dictionary.vue';

const data = inject('data');
</script>
